import React, {useEffect} from 'react';

import './PostTemplate.scss';

import Checkbox from 'components/Checkbox/Checkbox';
import {useGlobalState} from 'hooks/useGlobalState';
import {useSetGlobalState} from 'hooks/useSetGlobalState';

import PostSlider from '../shared/PostSlider/PostSlider';
import {setFieldsAC, setIsPriceCheckedAC} from '../slice';
import TemplateSlider from './TemplateSlider/TemplateSlider';

interface IProps {
  postRefs: React.MutableRefObject<HTMLDivElement[]>;
}

export default function PostTemplate({postRefs}: IProps) {
  const dispatch = useSetGlobalState();

  const {isPriceChecked} = useGlobalState((state) => state.postGenerator);

  const handleChange = () => {
    dispatch(setIsPriceCheckedAC(!isPriceChecked));
  };

  useEffect(() => {
    return () => {
      dispatch(setFieldsAC([]));
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div data-testid="postTemplate">
      <TemplateSlider />
      <div className="position-relative">
        <div className="post-template__price-checkbox">
          <Checkbox onChange={handleChange} checked={isPriceChecked} />
          <span className="post-template__checkbox-label">Show price</span>
        </div>
        <PostSlider />
        <div className="post-template__invisible">
          <PostSlider setRefs={postRefs} />
        </div>
      </div>
    </div>
  );
}
